import './index.scss';
import Initializer from 'lib/initializer';
import NewsletterSignupFormView from './scripts/view.js';

Initializer.registerComponent('site/newsletter_signup_form', (element, data) => {
  element.children.field_source.value = `${element.children.field_source.value}__${window.location.pathname}`;

  new NewsletterSignupFormView({ el: element, data: data });
});
